import type { IconComponent } from '@components/icons/types'

/** Plus (+) Symbol */
export const Plus: IconComponent = ({
    width = '18',
    height = '18',
    ...restOfProps
}) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...restOfProps}
    >
        <path
            d='M18 9L-7.86805e-07 9M9 -1.35896e-06L9 18'
            stroke='currentColor'
            strokeWidth='2'
        />
    </svg>
)
